import { render, staticRenderFns } from "./home-list.vue?vue&type=template&id=53be9159&scoped=true"
import script from "./home-list.vue?vue&type=script&lang=js"
export * from "./home-list.vue?vue&type=script&lang=js"
import style0 from "./home-list.vue?vue&type=style&index=0&id=53be9159&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53be9159",
  null
  
)

export default component.exports